import React from "react";
import PhilosophyFlow from "../components/philosophyFlow/PhilosophyFlow";
import styles from "../styles/philosophy.css";

const Philosophy = () => {
  return (
    <main className={styles.page}>
      <section className={styles.header}>
      </section>

      <section className={styles.treeWrapper}>
        <PhilosophyFlow />
      </section>
    </main>
  );
};

export default Philosophy;